/**
 * The words a screen uses for the people an organisation manages travel for. Driven by the organisation's
 * category (via its `defaultStaffType`) or, failing that, a staff record's own `type` — never by a table in
 * the Hub. `type` is the staff type code the labels were resolved from (`EMPLOYEE` when nothing better is
 * known).
 */
export interface OrganisationLabels {
  singular: string;
  plural: string;
  reference: string;
  type: string;
}

/** What every screen shows until the classification loads, or when nothing more specific is known. */
export const DEFAULT_ORGANISATION_LABELS: OrganisationLabels = {
  singular: 'Staff member',
  plural: 'Staff',
  reference: 'Employee number',
  type: 'EMPLOYEE',
};
